import { render } from "./Lecture.vue?vue&type=template&id=0d37a089&scoped=true"
import script from "./Lecture.vue?vue&type=script&lang=js"
export * from "./Lecture.vue?vue&type=script&lang=js"

import "./Lecture.vue?vue&type=style&index=0&id=0d37a089&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d37a089"]])

export default __exports__